import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject, of, empty, throwError } from "rxjs";
import { timeout, catchError } from "rxjs/operators";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import * as jwt_decode from "jwt-decode";
import { environment } from "../../../environments/environment";
import { UtilService } from "../util.service";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
  }),
};

@Injectable({
  providedIn: "root",
})
export class MappingToolService {
  private tileTypes: BehaviorSubject<string[]> = new BehaviorSubject<any>({});
  public tileTypes$: Observable<string[]> = this.tileTypes.asObservable();

  public userEmail: any;
  public orgId: any;
  userData: any;

  constructor(private http: HttpClient,
    private utilService: UtilService) {
    this.userEmail = jwt_decode(
      localStorage.getItem("AuthorizationD")
    ).userPayload.email;
    this.orgId = jwt_decode(
      localStorage.getItem("AuthorizationD")
    ).userPayload.orgId;
    this.userData = jwt_decode(
      localStorage.getItem("AuthorizationD")
    ).userPayload;
  }

  emitConfig(val) {
    this.tileTypes.next(val);
  }

  // public getFormsByOrg(orgName) {
  //   return this.http
  //     .get(
  //       environment.mappingToolAPIUrl + "/asg/form/org?orgName=" + orgName,
  //       httpOptions
  //     )
  //     .toPromise()
  //     .then((response: any) => response as any)
  //     .catch();
  // }
  public getFormsByOrgNew(orgName, pageDetails) {
    let params;
    orgName != "ACORD" ? (params = "Custom") : (params = orgName);
    let endpoint =
      environment.mappingToolAPIUrl +
      "/asg/form/v1/org?formType=" +
      params +
      "&pageSize=" +
      pageDetails.pageSize +
      (pageDetails.searchBy ?  "&searchBy=" + pageDetails.searchBy: '') +
      "&pageNum="+ +
      pageDetails.pageNum;
    if (pageDetails.textFilter) {
      endpoint += "&searchParam=" + pageDetails.textFilter;
    }
    if (pageDetails.tags && pageDetails.tags.length) {
      for (let tag of pageDetails.tags) {
        endpoint += "&tags=" + tag;
      }
    }
    if (pageDetails.dateFilter) {
      endpoint += "&date=" + pageDetails.dateFilter;
    }
    if (pageDetails.sortDetails) {
      endpoint +=
        "&orderByParam=" +
        pageDetails.sortDetails.orderByParam +
        "&orderByAsc=" +
        pageDetails.sortDetails.orderByAsc;
    }
    return this.http
      .get(endpoint, { observe: "response" })
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public getFormsByOrg(orgName, pageDetails) {
    let params;
    orgName != "ACORD" ? (params = "Custom") : (params = orgName);
    let endpoint =
      environment.mappingToolAPIUrl +
      "/asg/form/v2/org?formType=" +
      params +
      "&pageSize=" +
      pageDetails.pageSize +
      "&pageNum=" +
      pageDetails.pageNum;
    if (pageDetails.textFilter) {
      endpoint +=
        "&textFilterType=" +
        pageDetails.filterType +
        "&textFilter=" +
        pageDetails.textFilter;
    }
    if (pageDetails.tags && pageDetails.tags.length) {
      for (let tag of pageDetails.tags) {
        endpoint += "&tags=" + tag;
      }
    }
    if (pageDetails.dateFilterFrom) {
      endpoint += "&dateFrom=" + pageDetails.dateFilterFrom;
    }
    if (pageDetails.dateFilterTo) {
      endpoint += "&dateTo=" + pageDetails.dateFilterTo;
    }
    if (pageDetails.sortDetails) {
      endpoint +=
        "&orderByParam=" +
        pageDetails.sortDetails.orderByParam +
        "&orderByAsc=" +
        pageDetails.sortDetails.orderByAsc;
    }
    return this.http
      .get(endpoint, { observe: "response" })
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public saveFormsByUser(formData): Observable<any> {
    formData.orgId = this.orgId;
    formData.userId = this.userEmail;

    return this.http.post(
      environment.mappingToolAPIUrl + "/asg/form/save",
      formData,
      httpOptions
    );
  }

  public saveMappingDefinition(formData) {
    return this.http
      .post(
        environment.mappingToolAPIUrl + "/v1/client/excel/definitions",
        formData,
        httpOptions
      ).pipe(
        catchError((e) => {
          return throwError(e.error);
        })
      )
  }

  public deleteDefinitionById(defId) {
    return this.http
      .delete(
        environment.mappingToolAPIUrl + "/v1/excelmapping/definitions/" + defId,
        httpOptions
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public editDefinitionById(formdata, defId) {
    return this.http
      .put(
        environment.mappingToolAPIUrl + "/v1/excelmapping/definitions/" + defId,
        formdata,
        httpOptions
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public addMappingItemByDefinition(formdata, defId) {
    return this.http
      .post(
        environment.mappingToolAPIUrl +
          "/v1/client/excel/definitions/" +
          defId +
          "/items",
        formdata,
        httpOptions
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public addElementMapSynonyms(formdata) {
    return this.http
      .post(
        environment.mappingToolAPIUrl + "/v1/client/excel/elementmaps",
        formdata,
        httpOptions
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public deleteElementMapSynonyms(elmId) {
    return this.http
      .delete(
        environment.mappingToolAPIUrl + "/v1/client/excel/elementmaps/" + elmId,
        httpOptions
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public deleteItemElabel(defId, excelMappingItemKey) {
    return this.http
      .delete(
        environment.mappingToolAPIUrl +
          "/v1/excelmapping/definitions/" +
          defId +
          "/items/" +
          excelMappingItemKey,
        httpOptions
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public editElementMapSynonyms(formData, elmId) {
    return this.http
      .put(
        environment.mappingToolAPIUrl + "/v1/client/excel/elementmaps/" + elmId,
        formData,
        httpOptions
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public editMappingItemsById(formdata, defId, itemId) {
    return this.http
      .put(
        environment.mappingToolAPIUrl +
          "/v1/client/excel/definitions/" +
          defId +
          "/items/" +
          itemId,
        formdata,
        httpOptions
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public getFormsDetailsById(formId) {
    return this.http
      .get(
        environment.mappingToolAPIUrl + "/asg/form/details/id?formId=" + formId,
        httpOptions
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public getFormsDetailsByIdForClone(formId) {
    return this.http
      .get(
        environment.mappingToolAPIUrl + "/asg/form/details/id/clone?formId=" + formId,
        httpOptions
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public deleteFormById(formId) {
    const requestOptions: Object = {
      responseType: "text",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .put(
        environment.mappingToolAPIUrl +
          "/asg/form/delete/id?formId=" +
          formId.id,
        {},
        { responseType: "text" }
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch((error) => {
        console.log(error);
      });
  }

  public editFormsByUser(formData) {
    formData.orgId = this.orgId;
    formData.userId = this.userEmail;

    return this.http
      .put(
        environment.mappingToolAPIUrl + "/asg/form/update",
        formData,
        httpOptions
      ).pipe(
        catchError((e) => {
          return throwError(e.error);
        })
      );
  }

  public saveAcroName(acroPayloadObject) {
    let url = environment.mappingToolAPIUrl + "/asg/form/updateAcroFileName";
    return this.http
      .put(url, acroPayloadObject)
      .toPromise()
      .then((response: any) => response as any)
      .catch((err: any) => err as any);
  }
  public deleteSectionById(sectionId) {
    const requestOptions: Object = {
      responseType: "text",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    //https://dev-iforms.acordsolutions.net/Iforms-mappingtool-app/asg/form/delete/secition/?sectionId=9
    return this.http
      .delete(
        environment.mappingToolAPIUrl +
          "/asg/form/delete/secition/?sectionId=" +
          sectionId,
        requestOptions
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }
  public deleteFieldsById(formFieldId, formId) {
    const requestOptions: Object = {
      responseType: "text",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http
      .delete(
        environment.mappingToolAPIUrl +
          "/asg/FormField/delete?formFieldId=" +
          formFieldId +
          "&formId=" +
          formId,
        requestOptions
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public deleteAnchorFieldsById(formFieldId, formId) {
    const requestOptions: Object = {
      responseType: "text",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http
      .delete(
        environment.mappingToolAPIUrl +
          "/asg/FormField/refCoordinates/delete?formRefCoId=" +
          formFieldId +
          "&formId=" +
          formId,
        requestOptions
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public deleteSectionElabelsById(row, sectionId) {
    let deleteId;
    if (row.id) {
      deleteId = row.id;
    } else if (row.eLabelDetails.id) {
      deleteId = row.eLabelDetails.id;
    }
    const requestOptions: Object = {
      responseType: "text",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.http
      .delete(
        environment.mappingToolAPIUrl +
          "/asg/form/delete/secition/elabel?sectionId=" +
          sectionId +
          "&elabelId=" +
          deleteId,
        requestOptions
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }
  public deleteRulesById(ruleId) {
    const requestOptions: Object = {
      responseType: "text",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http
      .delete(
        environment.mappingToolAPIUrl +
          "/asg/rule/delete/formRule?formRuleId=" +
          ruleId,
        requestOptions
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public getExistingPDF(fileName) {
    return this.http
      .get(
        environment.iformWebformAPIUrl +
          "/asg/aws/s3/file?fileName=" +
          fileName +
          "&isEncode=true&bucketName="+this.utilService.bucketName,
        { responseType: "text" }
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public getBusinessProcessList(): Observable<any> {
    return this.http.get(
      environment.asgAdminUrl +
        "/public/v1/codes/_search?codeCatgoryName=BusinessProcess"
    );
  }

  public formNameValidation(source, formName): Observable<any> {
    return this.http.get(
      environment.mappingToolAPIUrl +
        "/asg/form/nameValidation?source=" +
        source +
        "&formName=" +
        formName
    );
  }

  public pdf2AcroFormConvert(formId): Observable<any> {
    return this.http.get(
      environment.mappingToolAPIUrl +
        "/asg/converter/pdf2acroform?formId=" +
        formId,
      { responseType: "text" }
    ).pipe(
      catchError((e) => {
        return throwError(e.error);
      })
    );
  }

  public trainEnable(formId): Observable<any> {
    return this.http.get(
      environment.mappingToolAPIUrl +
        "/asg/form/docrecognition/" +
        formId +
        "/train",
      { responseType: "text" }
    );
  }

  public trainEnableExcelV2(formId, s3Path): Observable<any> {
    let s3Url = encodeURI("s3://"+this.utilService.bucketName+"/" + s3Path);
    return this.http.get(
      environment.mappingToolAPIUrl +
        "/v1/client/excel/docrecognition/" +
        formId +
        "/train?s3Path=" +
        s3Url,
      { responseType: "text" }
    );
  }

  public forgetTraining(formId): Observable<any> {
    return this.http.get(
      environment.mappingToolAPIUrl +
        "/asg/form/docrecognition/" +
        formId +
        "/forgot",
      { responseType: "text" }
    );
  }

  public forgetTrainingExcelV2(formId): Observable<any> {
    return this.http.get(
      environment.mappingToolAPIUrl +
        "/v1/client/excel/docrecognition/" +
        formId +
        "/forgot",
      { responseType: "text" }
    );
  }

  public mlPythonServiceCall(formId, acroFileName): Observable<any> {
    return this.http.get(
      environment.mappingToolAPIUrl +
        "/asg/form/callToMLPythonService?formId=" +
        formId +
        "&acroFileName=" +
        acroFileName,
      { responseType: "text" }
    );
  }

  public pdf2sxd(formId): Observable<any> {
    return this.http.get(
      environment.mappingToolAPIUrl +
        "/asg/converter/acropdf2xsd?formId=" +
        formId,
      { responseType: "text" }
    );
  }

  public downloadMappingXSD(formId): Observable<any> {
    return this.http.get(
      environment.mappingToolAPIUrl + "/asg/form/" + formId + "/download/xsd",
      { responseType: "text" }
    );
  }

  public downloadExtractedCSVs(
    pageNumber,
    s3Location,
    preProcess = false
  ): Observable<any> {
    return this.http.get(
      environment.mappingToolAPIUrl +
        "/asg/automappings/detectPDFTable?s3Location=" +
        s3Location +
        "&pageNumber=" +
        pageNumber +
        "&preProcess=" +
        preProcess,
      { responseType: "arraybuffer", observe: "response" }
    );
  }

  public clearCache(formId): Observable<any> {
    return this.http.get(
      environment.iformWebformAPIUrl +
        "/asg/aws/extraction/clearCache?formId=" +
        formId,
      { responseType: "text" }
    );
  }

  public excelExtraction(formData, formId): Observable<any> {
    return this.http.post(
      environment.mappingToolAPIUrl + "/excel?formId=" + formId,
      formData,
      { responseType: "text" }
    );
  }

  public getFormFields(): Observable<any> {
    var endpoint = environment.mappingToolAPIUrl + "/asg/formLOBComposite/all";
    return this.http.get(endpoint);
  }

  public getConfigDatabyCategories(codeCategoryKey): Observable<any> {
    var endpoint =
      environment.asgAdminUrl +
      "/public/v1/codes/_search?codeCatgoryName=" +
      codeCategoryKey;
    return this.http.get(endpoint);
  }
  /** Direct POST to create codes given a categoryKey */
  public postCodesByCategoryKey(categoryKey: string, payload: any[]): Observable<any> {
    const endpoint = environment.asgAdminUrl + "/v1/codecategories/" + categoryKey + "/codes";
    return this.http.post(endpoint, payload, httpOptions);
  }

  /** Delete a code by categoryKey and codeKey */
  public deleteCodeByCategoryAndKey(categoryKey: string, codeKey: string): Observable<any> {
    const endpoint = environment.asgAdminUrl + "/v1/codecategories/" + categoryKey + "/codes/" + codeKey;
    return this.http.delete(endpoint, httpOptions);
  }

  public getAttributesByFilter(
    org,
    businessDomain,
    broadLineOfBusiness,
    lineOfBusiness
  ): Observable<any> {
    const URL =
      environment.mappingToolAPIUrl +
      "/asg/form/suggestedFormFields?org=" +
      org +
      "&businessDomain=" +
      encodeURIComponent(businessDomain) +
      "&broadLineOfBusiness=" +
      encodeURIComponent(broadLineOfBusiness) +
      "&lineOfBusiness=" +
      encodeURIComponent(lineOfBusiness) +
      "&orgId=" +
      this.orgId +
      "&userEmailId=" +
      this.userEmail;
    return this.http.get(URL).pipe(
      timeout(60000),
      catchError((e) => {
        console.log("Attribute Filter timeout");
        return of(null);
      })
    );
  }

  public checkIfUsedInAnotherOrg(searchValue): Observable<any> {
    var endpoint =
      environment.mappingToolAPIUrl +
      "/asg/formELabels/name/acrossOrgDuplicateCheck?elabelName=" +
      searchValue;
    return this.http.get(endpoint);
  }

  public getElabels(searchValue): Observable<any> {
    var endpoint =
      environment.mappingToolAPIUrl +
      "/asg/formELabels/name/like?elabelName=" +
      searchValue +
      "&orgId=" +
      this.orgId +
      "&userEmailId=" +
      this.userEmail;
    return this.http.get(endpoint);
  }

  // public getTags(searchValue): Observable<any> {
  //   var endpoint = environment.mappingToolAPIUrl + '/asg/form/elabel/fieldTags?elabelId=' + searchValue.elabelId + '&orgId=' + searchValue.orgId;
  //   return this.http.get(endpoint);
  // }

  public getOrganizationList(): Observable<any> {
    var endpoint = environment.asgAdminUrl + "/asg/admin/organizations";
    return this.http.get(endpoint);
  }

  public getOrganizationNameById(orgId) {
    let endpoint =
      environment.asgAdminUrl + "/asg/admin/organizations/" + orgId;
    return this.http.get(endpoint);
  }

  public getOrganizationById(orgId): Observable<any> {
    var endpoint = environment.asgAdminUrl + "/asg/admin/organization";
    // var endpoint = 'https://dev-iforms.acordsolutions.net/asg-admin/asg/admin/organization';
    return this.http.get(endpoint, orgId);
  }
  public getNonAcordForms(): Observable<any> {
    // https://dev-iforms.acordsolutions.net/Iforms-mappingtool-app/asg/form/org/non-acord
    var endpoint = environment.mappingToolAPIUrl + "/asg/form/org/non-acord";
    // var endpoint = 'https://dev-iforms.acordsolutions.net/Iforms-mappingtool-app/asg/form/org/non-acord';
    return this.http.get(endpoint);
  }
  public getAcordForms(): Observable<any> {
    // https://dev-iforms.acordsolutions.net/Iforms-mappingtool-app/asg/form/org/non-acord
    var endpoint =
      environment.mappingToolAPIUrl + "/asg/form/org?orgName=ACORD";
    // var endpoint = 'https://dev-iforms.acordsolutions.net/Iforms-mappingtool-app/asg/form/org/non-acord';
    return this.http.get(endpoint);
  }

  public getAllForms(): Observable<any> {
    var endpoint = environment.mappingToolAPIUrl + "/asg/form/all";
    return this.http.get(endpoint);
  }

  public getAllTags(): Observable<any> {
    var endpoint = environment.mappingToolAPIUrl + "/asg/form/all/tag";
    return this.http.get(endpoint);
  }

  public getFilterTags(orgId: any): Observable<any> {
    var endpoint =
      environment.mappingToolAPIUrl + "/asg/form/tag?orgId=" + orgId;

    return this.http.get(endpoint);
  }

  public deleteAcordForm(formData) {
    const requestOptions: Object = {
      responseType: "text",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http
      .put(
        environment.mappingToolAPIUrl +
          "/asg/form/delete/id?formId=" +
          formData.id,
        {},
        { responseType: "text" }
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch((error) => {
        console.log(error);
      });
  }

  public fetchAuditLogs(payload) {
    const requestOptions: Object = {
      // responseType: 'text',
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http
      .post(
        environment.mappingToolAPIUrl + "/v1/audits/FORMMAPPING",
        payload,
        requestOptions
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public pdf2HtmlFormConvert(data, formDetails) {
    const requestOptions: Object = {
      responseType: "text",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http
      .post(
        environment.mappingToolAPIUrl +
          "/v1/asg/converters/pdftohtml?sourceName=" +
          formDetails.source +
          "&formName=" +
          formDetails.formName +
          "&edition=" +
          formDetails.edition,
        data,
        requestOptions
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public uploadAcroPDF(formData, formName, formOrg, version) {
    return this.http
      .post(
        environment.iformWebformAPIUrl +
          "/asg/aws/s3/uploadFile?formName=" +
          formName +
          "&formOrg=" +
          formOrg +
          "&version=" +
          version,
        formData
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public uploadAcroExcel(formData, formName, formOrg, version, docType) {
    return this.http
      .post(
        environment.iformWebformAPIUrl +
          "/asg/aws/s3/uploadFile?formName=" +
          formName +
          "&formOrg=" +
          formOrg +
          "&version=" +
          version +
          "&docType=" +
          docType,
        formData
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public deleteTag(tagInfo) {
    //DELETE   asg/form/tag/delete?formId=4F6DF74F-2AAF-3F78-86AB-97BCA5C1AB17&tagId=51
    const requestOptions: Object = {
      responseType: "text",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http
      .delete(
        environment.mappingToolAPIUrl +
          "/asg/form/tag/delete?formId=" +
          tagInfo.formId +
          "&tagId=" +
          tagInfo.tagId,
        requestOptions
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public getAllRulesByOrg(orgId) {
    return this.http
      .get(
        environment.mappingToolAPIUrl + "/asg/rule/org?orgId=" + orgId,
        httpOptions
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public getAllFormsByRuleId(ruleId) {
    return this.http
      .get(
        environment.mappingToolAPIUrl +
          "/asg/rule/attach/formRule?ruleId=" +
          ruleId,
        httpOptions
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public removeRuleAttachByFormId(formId, ruleId) {
    return this.http
      .delete(
        environment.mappingToolAPIUrl +
          "/asg/rule/delete/attachedForm?formId=" +
          formId +
          "&ruleId=" +
          ruleId,
        { responseType: "text" }
      )
      .toPromise()
      .then((response: any) => response as any)
      .catch();
  }

  public attachFormWithRule(formData: any): Observable<any> {
    var endpoint = environment.mappingToolAPIUrl + "/asg/rule/save/formRule";

    return this.http.post(endpoint, formData);
  }

  public saveRule(formData: any): Observable<any> {
    var endpoint = environment.mappingToolAPIUrl + "/asg/rule/save";

    return this.http.post(endpoint, formData);
  }

  public updateRule(formData: any): Observable<any> {
    var endpoint = environment.mappingToolAPIUrl + "/asg/rule/update";

    return this.http.put(endpoint, formData);
  }


  public automappingFindPageAttribute(
    autoMappingPayload: any
  ): Observable<any> {
    let docType = "";
    if (autoMappingPayload.docType && autoMappingPayload.docType != "") {
      docType = "&docType=" + autoMappingPayload.docType;
    }
    let url =
      environment.mappingToolAPIUrl +
      "/asg/automappings/findPageAttributes?s3Location=" +
      autoMappingPayload.s3Location +
      "&pageNumber=" +
      autoMappingPayload.pageNumber +
      "&pxWidth=" +
      autoMappingPayload.pxWidth +
      "&pxHeight=" +
      autoMappingPayload.pxHeight +
      autoMappingPayload.extraParam +
      docType;

    return this.http.get(url);
  }

  public downloadPopulationPostmanCollection(): Observable<any> {
    return this.http.get(
      environment.mappingToolAPIUrl + "/postmancollection/population",
      { responseType: "text" }
    );
  }

  public downloadFormsDownloadPostmanCollection(): Observable<any> {
    return this.http.get(
      environment.mappingToolAPIUrl + "/postmancollection/download",
      { responseType: "text" }
    );
  }

  public downloadExtractionPostmanCollection(): Observable<any> {
    return this.http.get(
      environment.mappingToolAPIUrl + "/postmancollection/extraction",
      { responseType: "text" }
    );
  }
  public getOcrModels(formId) {
    return this.http.get(
      environment.mappingToolAPIUrl + "/v1/ocrnearestneighbormodels/forms/"+formId
    );
  }
  public getOcrNNModels(formId) {
    return this.http.get(
      environment.mappingToolAPIUrl + "/ocrmodel/nn-ref-data/"+formId
    );
  }
  public createOcrModels(formId) {
    return this.http.post(
      environment.mappingToolAPIUrl + "/v1/ocrnearestneighbormodels/forms/"+formId,
      {}
    );
  }
  public updateOcrModels(formId, payload) {
    return this.http.put(
      environment.mappingToolAPIUrl + "/v1/ocrnearestneighbormodels/forms/"+formId,
      payload
    );
  }
  public updateNNOcrModels(payload) {
    return this.http.put(
      environment.mappingToolAPIUrl + "/ocrmodel/nn-ref-data",
      payload
    );
  }
  public debugOcrModel(formId, payload) {
    let headers = new HttpHeaders().set('Content-Type', 'text/plain');
    return this.http.post(
      environment.mappingToolAPIUrl + "/v1/ocrnearestneighbormodels/debug/forms/"+formId,
      payload,
      { headers, responseType: "text" }
    );
  }
  public deleteOcrModels(formId) {
    return this.http.delete(
      environment.mappingToolAPIUrl + "/v1/admin/forms/ocrmodels/"+formId
    );
  }
  public deleteOcrNNModels(formId) {
    return this.http.delete(
      environment.mappingToolAPIUrl + "/ocrmodel/nn-ref-data/"+formId,
      { responseType: "text" }
    );
  }
  public getOcrModelTemplateData(formId) {
    return this.http.get(
      environment.mappingToolAPIUrl + "/v1/ocrnearestneighbormodels/templates/forms/"+formId);
  }
  public updateOcrModelsTemplateData(formId, payload) {
    return this.http.put(
      environment.mappingToolAPIUrl + "/v1/ocrnearestneighbormodels/templates/forms/"+formId, payload);
  }
  public getForManagement(formId, payload) {
    let headers = new HttpHeaders().set('Content-Type', 'text/plain');
    return this.http.post(
      environment.mappingToolAPIUrl + "/v1/formmanagement/forms/"+formId, payload,
      { headers, responseType: "text" });
  }
  public getFormManagementFields(formId) {
    return this.http.get(environment.mappingToolAPIUrl + "/v1/formmanagement/forms/"+formId+"/formfields");
  }
  public getFormManagementFieldsCoordinates(formId, fieldId) {
    return this.http.get(environment.mappingToolAPIUrl + `/v1/formmanagement/forms/${formId}/formfields/${fieldId}/coordinates`);
  }
  public deleteSplitAddressData(formId, fieldId) {
    return this.http.delete(environment.mappingToolAPIUrl + `/v1/forms/${formId}/addressspiltmodels/${fieldId}`);
  }
  public getSplitAddressData(formId) {
    return this.http.get(environment.mappingToolAPIUrl + `/v1/forms/${formId}/addressspiltmodels`);
  }
  public createSplitAddressField(payload, formId) {
    return this.http.post(environment.mappingToolAPIUrl + `/v1/forms/${formId}/addressspiltmodels`, payload);
  }
  public updateSplitAddressField(payload, formId) {
    return this.http.put(environment.mappingToolAPIUrl + `/v1/forms/${formId}/addressspiltmodels/${payload.acordFormAddressSplitKey}`, payload);
  }
  public createFormManagementFields(formId, payload) {
    return this.http.post(environment.mappingToolAPIUrl + "/v1/formmanagement/forms/"+formId+"/formfields", payload);
  }
  public cloneNNModel(payload) {
    return this.http.post(environment.mappingToolAPIUrl + "/ocrmodel/nn-ref-data/clone", payload, { responseType: "text" });
  }
  public createFormManagementFieldsCoordinates(formId, fieldId, payload) {
    return this.http.post(environment.mappingToolAPIUrl + `/v1/formmanagement/forms/${formId}/formfields/${fieldId}/coordinates`, payload);
  }
  public updateFormManagementFields(formId,payload) {
    return this.http.put(environment.mappingToolAPIUrl + "/v1/formmanagement/forms/"+formId+"/formfields/"+payload.id, payload);
  }
  public updateFormManagementFieldsCoordinates(formId, fieldId,payload) {
    return this.http.put(environment.mappingToolAPIUrl + `/v1/formmanagement/forms/${formId}/formfields/${fieldId}/coordinates/`+payload.id, payload);
  }
  public deleteFormManagementFields(formId, fieldId) {
    return this.http.delete(environment.mappingToolAPIUrl + "/v1/formmanagement/forms/"+formId+"/formfields/"+fieldId);
  }
  public deleteFormManagementFieldsCoordinates(formId, fieldId, coordinateId) {
    return this.http.delete(environment.mappingToolAPIUrl + `/v1/formmanagement/forms/${formId}/formfields/${fieldId}/coordinates/`+coordinateId);
  }
  public uploadMigrationRequest(payload) {
    return this.http.post(environment.mappingToolAPIUrl + `/v1/migrations/uploadrequest`, payload, { responseType: "text" });
  }
  public uploadMigrationRequestStatus(requestId) {
    return this.http.get(environment.mappingToolAPIUrl + `/v1/migrations/uploadrequest/${requestId}/status`, { responseType: "text" });
  }

  public downloadMigrationRequest(payload) {
    return this.http.post(environment.mappingToolAPIUrl + `/v1/migrations/downloadrequest`, payload, { responseType: "text" });
  }
  public downloadMigrationRequestGet(requestId) {
    return this.http.get(requestId, { responseType: "blob" });
  }
  public downloadCsv(payload) {
    return this.http.get(environment.customModelsAPIUrl+`/v1/custommodels/generate/csv?s3Location=s3://${this.utilService.bucketName}/${payload.fileName}&insuranceDocType=${payload.insuranceDocType}&insuranceDocIdentifier=${payload.insuranceDocIdentifier}`, { responseType: "blob" });
  }
  public downloadMigrationRequestStatus(requestId) {
    return this.http.get(environment.mappingToolAPIUrl + `/v1/migrations/downloadrequest/${requestId}/status`, { responseType: "text" });
  }
  public ocrModalCheck(fmtId) {
    return this.http.get(environment.mappingToolAPIUrl + `/v1/ocrnearestneighbormodels/forms/${fmtId}`, { responseType: "text", observe: "response" });
  }
  public ocrModalDownloadMapping(fmtId) {
    const httpOptions = new HttpHeaders().set("Accept","text/csv");
    return this.http.get(environment.mappingToolAPIUrl + `/v1/ocrnearestneighbormodels/forms/${fmtId}`, {headers: httpOptions, responseType: "text"});
  }

  public createAcordForm(payload){
    return this.http.post(environment.mappingToolAPIUrl + '/v1/formmanagement/forms/acord', payload).pipe(
      catchError((e) => {
        return throwError(e.error);
      })
    );
  }
  autoDetectForm(base64String) {
    return this.http.post(
      environment.mappingToolAPIUrl +
        "/asg/automappings/v1/getFormAttributes", base64String)
  }
  public getPipelineValues(id) {
    return this.http.get(environment.mappingToolAPIUrl + "/v2/aiml/configurations/pipelines?tenantId="+id);
  }
  public getAsgAimlModelsConfiguration(id) {
    return this.http.get(environment.mappingToolAPIUrl + "/v1/asgAimlModelsConfiguration/uienabled");
  }
  public postPipelineConfiguration(payload) {
    return this.http.post(environment.mappingToolAPIUrl + "/v1/aiml/configurations/pipelines", payload);
  }
  public getPipelineLabel(payload) {
    return this.http.post(environment.mappingToolAPIUrl + "/v1/aiml/configurations/labels/_search", payload);
  }
  public postPipelineLabel(payload) {
    return this.http.post(environment.mappingToolAPIUrl + "/v1/aiml/configurations/labels", payload);
  }
  public deleteLabel(payload) {
    return this.http.delete(environment.mappingToolAPIUrl + "/v1/aiml/configurations/labels", {body:payload});
  }
  public getClauseNames(orgId) { 
    return this.http.get(environment.mappingToolAPIUrl + '/v1/aiml/configurations/clauseLibraries/names?tenantId='+orgId);
  }
  public getClauseData(orgId,clauseName) { 
    return this.http.get(environment.mappingToolAPIUrl + `/v1/aiml/configurations/clauseLibraries?tenantId=${orgId}&clauseLibraryName=${clauseName}`);
  }
  public createClauseDefinition(payload) {
    return this.http.post(environment.mappingToolAPIUrl+'/v1/aiml/configurations/clauseLibraries', payload)
  }
  public deleteClauseDefinition(orgId, clauseName) {
    return this.http.delete(environment.mappingToolAPIUrl+`/v1/aiml/configurations/clauseLibraries?tenantId=${orgId}&clauseLibraryName=`+clauseName)
  }
  public getDynamicPipelineConfiguration() {
    return this.http.get(environment.mappingToolAPIUrl + "/v2/aiml/ui/configurations");
  }
  public getPipelineConfigurationV2(payload) {
    return this.http.post(environment.mappingToolAPIUrl + "/v2/aiml/configurations/pipelines/_search", payload);
  }
  public postPipelineConfigurationV2(payload) {
    return this.http.post(environment.mappingToolAPIUrl + "/v2/aiml/configurations/pipelines", payload);
  }
  public deletePipelineV2(payload) {
    return this.http.delete(environment.mappingToolAPIUrl + "/v2/aiml/configurations/pipelines", {body: payload});
  }
  public auditLogSearch(payload) {
    return this.http.post(environment.mappingToolAPIUrl + "/v1/useractivity/search", payload);
  }
  public nerSettingSaveColumns(payload) {
    return this.http.post(environment.mappingToolAPIUrl + "/v1/ner/configurations", payload);
  }
  public nerSettingUpdateColumns(payload, id) {
    return this.http.put(environment.mappingToolAPIUrl + "/v1/ner/configurations/"+id, payload);
  }
  public getNerSettingColumns(orgId) {
    return this.http.get(environment.mappingToolAPIUrl + "/v1/ner/configurations/organizations/"+orgId);
  }
  public deleteNerSettingColumns(id) {
    return this.http.delete(environment.mappingToolAPIUrl + "/v1/ner/configurations/"+id);
  }
  public saveAimlConfiguration(payload) {
    return this.http.post(environment.mappingToolAPIUrl + "/v1/asgAimlModelsConfiguration", payload);
  }
  public updateAimlConfiguration(payload, id) {
    return this.http.put(environment.mappingToolAPIUrl + "/v1/asgAimlModelsConfiguration/"+id, payload);
  }
  public getAimlConfiguration(orgId) {
    return this.http.get(environment.mappingToolAPIUrl + "/v1/asgAimlModelsConfiguration/orgId/"+orgId);
  }
  public deleteAimlConfiguration(id) {
    return this.http.delete(environment.mappingToolAPIUrl + "/v1/asgAimlModelsConfiguration/"+id);
  }
  public getAimlConfigurationUiEnabled(orgId) {
    return this.http.get(environment.mappingToolAPIUrl + "/v1/asgAimlModelsConfiguration/uienabled");
  }
  public cacheClean(insurance_doc_type) {
    return this.http.get(environment.iformWebformAPIUrl + `/asg/aws/population/clearCacheByKey?cacheKey=TRANSCRIBER_FRM_PAGE_STR_BY_INS_DOC_TYPE_CACHE_KEY_${insurance_doc_type}`, { responseType: "text" });
  }
  
  /**
   * get section test data
   * @param payload 
   * @returns 
   */
  public sectionExtraction(payload: any) {
    return this.http.post(environment.mappingToolAPIUrl + "/v1/sectionextractor", payload);
  }

   /**
   * get section test data
   * @param payload 
   * @returns 
   */
   public changeLogExtraction(payload: any, type) {
    if(type == 'Change-Log') {
      return this.http.post(environment.mappingToolAPIUrl + "/v1/audits/FORMMAPPING", payload);
    } else {
      return this.http.post(environment.mappingToolAPIUrl + "/v1/audits/FORMMIGRATION", payload);
    }
  }
  public downloadPostProcessingJson(insuranceDocIdentifier,insuranceDocType): Observable<any> {
    return this.http.get(
      environment.customModelsAPIUrl + `/v1/custommodels/rules/download?insuranceDocIdentifier=${insuranceDocIdentifier}&insuranceDocType=${insuranceDocType}`,
      { responseType: "text",observe: 'response' }
    );
  }
  public uploadPostProcessing(payload, data) {
    return this.http.post(environment.customModelsAPIUrl + `/v1/custommodels/rules/upload?insuranceDocType=${data.insuranceDocType}&insuranceDocIdentifier=${data.insuranceDocIdentifier}`, payload, { responseType: "text" });
  }
  public validatePncXml(payload,al3Version) {
    const al3VersionParam = al3Version ? '?usPncXmlVersion='+al3Version : '';
    return this.http.post(environment.iformWebformAPIUrl+`/v1/pnc/xml/validate`+al3VersionParam, payload);
  }
  getNerTrainSheet(id, orgId) {
    return this.http.get(
      environment.mappingToolAPIUrl + `/v1/ner/organizations/${orgId}/nertrainings/${id}`
    );
  }
  saveNerTrainSheet(orgId, payload) {
    return this.http.post(
      environment.mappingToolAPIUrl + `/v1/ner/organizations/${orgId}/nertrainings`, payload
    );
  }
  updateNerTrainSheet(id, orgId, payload) {
    return this.http.put(
      environment.mappingToolAPIUrl + `/v1/ner/organizations/${orgId}/nertrainings/${id}`, payload
    );
  }
  searchNerTrainSheet(orgId, payload) {
    return this.http.post(
      environment.mappingToolAPIUrl + `/v1/ner/organizations/${orgId}/nertrainings/_search`, payload
    );
  }
  public deleteNerSheet(orgId,dataKey) {
    return this.http
      .delete(
        environment.mappingToolAPIUrl + `/v1/ner/organizations/${this.orgId}/nertrainings/${dataKey}`,
        httpOptions
      )
  }
  mrcToCrpPayload(payload) {
    return this.http.post(
      environment.iformWebformAPIUrl + `/transcriber/mrcelabeltocrp/convert`, payload
    );
  }
   public getMappingConfigData(orgId, docType, lobCode) {
    return this.http.get(environment.mappingToolAPIUrl + `/v1/transformations/organizations/${orgId}/custommodels/${docType ? docType : 'sov'}/${lobCode}/configurations`);
  }
  public saveMappingConfigData(orgId,selectedConfiguration, payload) {
    const docType = selectedConfiguration.docType
    const lob = selectedConfiguration.lineOfBusiness;
    const aimiKey = selectedConfiguration.aimlModelsConfigurationKey;
    const transformationLocaiton = selectedConfiguration.transformationMapperLocation;
    return this.http.post(environment.mappingToolAPIUrl + `/v1/transformations/organizations/${orgId}/custommodels/${!transformationLocaiton ? aimiKey+'/' : ''}${docType ? docType : 'sov'}/${lob}/configurations`, payload);
  }
  public downloadOnBoardingStats(obj): Observable<any> {
    var endpoint = environment.asgAdminUrl + `/v1/organizations/onboarding/stats?startDate=${obj.startDate}&endDate=${obj.endDate}`;
    return this.http.get(endpoint, { responseType: "blob" } );
  }
} 